import * as React from "react";
import { Tag } from "@chakra-ui/react";
import useTranslations from "../../hooks/useTranslations";
import UserAvatar from "../utils/avatars/UserAvatar";
import { ReviewMinimalFragment, UserReviewFragment } from '../../graphql/generated/definitions';

type FollowUpPlateProps = {
  review: ReviewMinimalFragment;
  user: UserReviewFragment;
};

export const FollowUpPlate: React.FC<FollowUpPlateProps> = ({ review, user }) => {
  const t = useTranslations();
  const isCollaborator = review.collaborator.id === user.id;

  return (
    <div className="flex items-center justify-between px-6 py-4 my-2 text-sm rounded cursor-pointer bg-light-0">
      <div className="flex items-center w-5/12 space-x-4">
        <UserAvatar src={user.avatar} alt="user avatar" size={8} />
        <p className="text-sm truncate overflow-ellipsis">
          {review.collaborator ? review.collaborator.name : t("reviews.unassigned")}
        </p>
      </div>
      <p className="w-4/12 text-sm truncate overflow-ellipsis">
        {review.campaign.name}
      </p>
      <div className="w-3/12 text-right">
        <Tag colorScheme={isCollaborator ? "blue" : "purple"}>
          {isCollaborator ? t("reviews.collaborator") : t("reviews.referent", { count: 0 })}
        </Tag>
      </div>
    </div>
  );
};
